import {request} from '../helpers/request'
import React from 'react';
import {t} from '../helpers/translate'
let config = require('config');

class Upload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      bulkUploadId: '',
      url: `${config.default.api}/regeneratepdfs/`,
    }
  }

  saveResponseData(data, statusCode) {
    return;
  }

  sendData() {
    request(this.state.url+this.state.bulkUploadId, 'GET', null, this.saveResponseData.bind(this));
  }

  updateBulkUploadId(event){
    this.setState({bulkUploadId: event.target.value})
  }

  checkBukUploadIdLength(){
    return this.state.bulkUploadId.length == 36
  }

  render() {
    const url = `${config.default.api}/sources/`;

    return (<div className="container">
      <div className="text-center bg-inherit">
        <h2>{t('Bulk PDF Regeneration')}</h2>
      </div>
      <div className="row">
        <input type='text' onChange={this.updateBulkUploadId.bind(this)}></input>
        <button className="btn btn-lg button-primary" className={!this.checkBukUploadIdLength() ? 'disabled-button' : ''} bsStyle="primary" onClick={this.sendData.bind(this)}>
          {t('Regenerate PDFs')}
        </button>
      </div>
      <br />
    </div>);
  }
}

Upload.defaultProps = {};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/Regenerate.js